
import { Container, Row, Nav, Stack, Accordion } from 'react-bootstrap';
import { Link } from '@mui/material';
import React from 'react';
import Markdown from '../Markdown';

const Motivation = ({  lang}) => {

    const title = lang === 'eng'? 'Making of this blog' : 'Motivația din spatele acestui blog'
    const motivation= `
By now, I have written a dozen of these posts so I think I can now formulate the whys, the hows, and the whats to myself.
<br/>
I have no intent whatsoever in making my ancestors sound grander or more interesting than I think they were. But I am not historian either.
I heard somewhere that someone excessively proud of their ancestors are like potatoes: the best part is underground! I have no interest whatsoever in being a potato!
<br/>

I write mainly for myself. I feel like an old fashioned wireless that you need to turn the dial carefully to tune in to the past; sometimes I get just static, other times I feel immersed in these stories. 
My stories are a last token of appreciation and thanks for the people that came before me. 
I hope one day my children, my nephew and niece will appreciate them. 
I was not interested in these old stories for a very long time so I don't think they will be. But the stories will be all written down and waiting for them, with all my love, when they are ready.
<br/>

I wonder what to include and what to leave out. I like to think that some of these stories have some historical, sociological or cultural interest beyond family and friends but it is not my primary concern.  I include my comments on the events and some authorial voice, because, hey, it’s my blog and why not. 
<br/>

I try to describe the source of my information: be it official documents, letters, a monument, books. Other times my sources are stories that others told me, and I hope to remember to say so and to give some context why I believe them enough to include them. 
If it’s something I witnessed as a child but I only understood later, I try to make that clear. Sometimes I do a bit of research i.e. some online searches and a look at wikipedia and other sites not much more than this. 
<br/>

It helps that my brother and I are the only descendants for many of the people I mention here, otherwise I would feel obliged to ask for their permission when I write about them. I will see when I get closer to the present, what I will include and what I leave out for privacy.
For the photos I include, I hope I mention all that are not from my family archive but I include them occasionally, with credit, when I think they illustrate my stories. Occasionally, I tried to colourise my old photos, for fun.
<br/>

It’s the past of my family that I write about here. I hope it informs my present to live better and a more meaningful life and that it will do the same in the future for any descendants or readers.
    `
    
    const motivationRom= `
Am scris până acum vreo duzina, așa că sunt la punctul de a formula de ce, cum și ce scriu.
<br/>
Nu am nicio intenție să-i fac pe strămoșii mei să 
sune mai interesanți decât cred că au fost.  Dar nici istoric nu sunt!
Nu mai țin minte de unde am auzit asta dar cei care sunt excesiv de mândri de strămoșii lor sunt ca si cartofii: 
cea mai bună parte este sub pământ! Nu am niciun interes să fiu cartof!

Scriu mai ales pentru mine; am descoperit că trebuie să fiu într-o anumită stare pentru a o face. 
Mă simt ca un radio vechi la care trebuie să rotești butonul cu atenție pentru a prinde frecventa cu trecutul; uneori  prinzi doar bruiaj.
 
Mă gândesc la poveștile mele ca pe un ultim semn de apreciere și mulțumire pentru stramosii mei. 
Sper că într-o zi copiii mea, nepotul și nepoata mei îi vor descoperi si aprecia. 
Nici pe mine nu m-au interesat foarte mult timp acele povești vechi pîna recent, așa că nu ma astept că ei vor aprecia asta prea curînd. 
Dar totul va fi scris și așteptându-i, cu toată dragostea mea, când vor dori sa afle mai multe.

Uneori mă întreb ce să includ și ce să omit. Îmi place să cred că unele dintre aceste povești au un un anume interes istoric, sociologic sau cultural dincolo de familie și prieteni, dar nu am urmărit acest lucru in mod deosebit. 
Am inclus comentariile mele despre evenimente și o voce de autor, pentru că, hei, este blogul meu și de ce nu. 

Încerc să descriu sursa informațiilor mele: uneori sunt documente oficiale, scrisori, un monument, cărți. Alteori, sursele mele sunt povești pe care mi le-au spus alții și sper să îmi amintesc să spun cum au ajuns la mine și să dau un context de ce le cred suficient pentru a le include. 
Când este cazul, fac un pic de cercetare, adică câteva căutări online sau citesc pe wikipedia, sau site-uri românești. 

Eu și fratele meu suntem singurii descendenți pentru mulți dintre oamenii pe care îi menționez aici; altfel m-aș simți obligat să le cer permisiunea altor descendenti atunci când scriu despre ei. 
Voi vedea când mă apropii de prezent, ce voi include și ce nu din motive de intimitate.

Pentru fotografiile pe care le includ, intenția mea e sa precizez cînd nu sunt din arhiva mea, dar le includ ocazional, cu credit, când cred că îmi ilustrează poveștile. 
Ocazional, am încercat să colorez fotografiile vechi din curiozitate.

Scriu aici despre trecutul familiei mele. Sper să-mi informeze prezentul să trăiesc mai bine și o viață mai plină de sens și că va face același lucru în viitor pentru orice descendenți sau cititori.
    `
    
    const content = lang==='eng'? motivation: motivationRom
    return (
        <>
            <Container style={{ height: '100%' }}>
                <br />
                <h3>
                    {title}
                </h3>

                <br />
                <Stack gap={3}>
                    <a id='experimental'>
</a>
      <Markdown className="markdown" sx={{ display: 'relative' }} key='motivation' >
                {content}
            </Markdown>
  
                    <h4> Back to
                        {<Link href={`../?lang=${lang}`}> Main Page</Link>}

                    </h4>
                    <br></br>      <br></br>
                </Stack>
                <Row className="justify-content-between">

                </Row>
            </Container>
        </>
    )
};



// const Motivation = ({ urlSearchParameters, lang, linkId, text, leftLinkId, leftLinkText, rightLinkId, rightLinkText, likes, comments, onLikesUpdated, onCommentsUpdated }) => {

//     return (
//         <>
//             <Container>
//                 <br/>
//                 <br/>
//                 Recipe 1
//                 ...
//                 Recipe 2
//                 ...
//             </Container>
//         </>
//     )
// }


export default Motivation;